var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vl-parent"},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }